import ApiSharedViewSession from "./session"
import ApiSharedView from './shared-view'
import ApiSharedViewApp from 'app/shared-view/gd/api/shared-view-app'
import ApiAttachment from "core/gd/api/attachment"
import ApiSharedEvents from "./events"

const Api = {
    Session         : new ApiSharedViewSession(),

    SharedView      : new ApiSharedView(),
    SharedViewApp   : new ApiSharedViewApp(),

    Attachment      : new ApiAttachment(),
    Events          : new ApiSharedEvents(),
};

module.exports = Api;